import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Modal from "react-modal";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { convertThenFormat, formatDateTime } from "../../common-data/Converts";
import DFApprovalForm from "./DFApprovalForm";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import DetailListings from "../couple-approval/DetailListings";
import { CheckCircleIcon, CrossCircleIcon } from "../../../images/icons/icons";

const DFApprovalListings = ({
  userInfoData,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  callFunction,
}) => {
  const { dfApprovalsLoading, dfApprovalsError, dfApprovals } = useSelector(
    (state) => state.payment
  );

  const isAdmin = userInfoData?.account_type === "admin";
  // const isClusterManager = userInfoData?.account_type === "cluster_manager";

  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);
  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
    isViewOnly: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  useEffect(() => {
    if (
      !dfApprovalsLoading &&
      !dfApprovalsError &&
      dfApprovals?.status &&
      dfApprovals?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: dfApprovals.data,
        pagination:
          dfApprovals?.pagination?.length > 0 ? dfApprovals.pagination : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [dfApprovalsLoading, dfApprovalsError, dfApprovals]);

  const tbColumns = [
    isAdmin && {
      dataField: "details",
      text: "documents (view/ Approve/ Reject)",
      formatter: (_, row) => {
        return (
          <div
            className="actionButtonContainer"
            style={{
              flexDirection: "column",
              justifyContent: "center",
              gap: "0",
            }}
          >
            <button
              className="actionBtn icon"
              onClick={() => {
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "approval_form",
                  rowData: row,
                  isViewOnly:
                    row?.document_status === "pending" ||
                    row?.approval_status !== "pending",
                }));
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-eye-fill"
                viewBox="0 0 16 16"
              >
                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
              </svg>
            </button>
          </div>
        );
      },
    },
    {
      dataField: "user_id",
      text: "Primary member Details",
      formatter: (_, row) => {
        const member1 = row?.member_details?.[0];

        return (
          <span className="tb-data">
            {member1?.name || "NA"}
            <br />
            <small className="lowercase underline">
              {member1?.mobile || ""}
              <br />
              {member1?.email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "user_id",
      text: "second member Details",
      formatter: (_, row) => {
        const member1 = row?.member_details?.[1];

        return (
          <span className="tb-data">
            {member1?.name || "NA"}
            <br />
            <small className="lowercase underline">
              {member1?.mobile || ""}
              <br />
              {member1?.email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "gym_id",
      text: "gym name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    // {
    //   dataField: "user_id",
    //   text: "Primary member Details",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data">
    //         {row?.primary_users_name || "NA"}
    //         <br />
    //         <small className="lowercase underline">
    //           {row?.primary_users_mobile || ""}
    //           <br />
    //           {row?.primary_users_email || ""}
    //         </small>
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "document_status",
      text: "document status",
      formatter: (_, row) => {
        const documentsArrLength = row?.document_details?.length || 0;

        return (
          <span
            className="tb-data text-center icon link minWidth100"
            onClick={() => {
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "approval_form",
                rowData: row,
                isViewOnly:
                  row?.document_status === "pending" ||
                  row?.approval_status !== "pending",
              }));
            }}
          >
            <b>{documentsArrLength}/2</b>{" "}
            {row?.document_status === "completed" ? (
              <CheckCircleIcon />
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-hourglass-split"
                viewBox="0 0 16 16"
                style={{ color: "#d9610b" }}
              >
                <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z" />
              </svg>
            )}
          </span>
        );
      },
    },
    {
      dataField: "approval_status",
      text: "Approval Status",
      formatter: (_, row) => {
        return (
          <span className="tb-data text-center icon">
            {row?.approval_status === "approved" ? (
              <CheckCircleIcon />
            ) : row?.approval_status === "rejected" ? (
              <CrossCircleIcon />
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-hourglass-split"
                viewBox="0 0 16 16"
                style={{ color: "#d9610b" }}
              >
                <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z" />
              </svg>
            )}
          </span>
        );
      },
    },
    // {
    //   dataField: "user_id",
    //   text: "Primary member Details",
    //   formatter: (_, row) => {
    //     const member1 = row?.member_details?.[0];

    //     return (
    //       <span className="tb-data">
    //         {member1?.name || "NA"}
    //         <br />
    //         <small className="lowercase underline">
    //           {member1?.mobile || ""}
    //           <br />
    //           {member1?.email || ""}
    //         </small>
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "user_id",
    //   text: "Partner Details",
    //   formatter: (_, row) => {
    //     const member1 = row?.member_details?.[1];

    //     return (
    //       <span className="tb-data">
    //         {member1?.name || "NA"}
    //         <br />
    //         <small className="lowercase underline">
    //           {member1?.mobile || ""}
    //           <br />
    //           {member1?.email || ""}
    //         </small>
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "plan_id",
    //   text: "Plan",
    //   formatter: (_, row) => {
    //     return <span className="tb-data">{row?.plan_name || "NA"}</span>;
    //   },
    // },
    // {
    //   dataField: "start_date",
    //   text: "plan duration",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data minWidth100 underline">
    //         {row?.start_date ? convertStraight(row.start_date) : "-"}
    //         <br />
    //         {row?.expire_date ? convertStraight(row.expire_date) : "-"}
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "extend_days",
    //   text: "extend days",
    //   formatter: (_, row) => {
    //     return <span className="tb-data">{row?.extend_days || 0}</span>;
    //   },
    // },
    {
      dataField: "plan_price",
      text: "Plan Price",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data link"
            onClick={() => {
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "view_details",
                rowData: row,
              }));
            }}
          >
            ₹{convertThenFormat(row?.plan_price || 0)}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "date added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        {modValues.modName === "view_details" ? (
          <div className={`createNewCTOModalContainer mod-width-50p`}>
            <ModalHeadAndClose
              title={
                modValues.rowData?.plan_name ||
                modValues.modName?.replace(/_/g, " ")
              }
              onClose={onCloseModal}
            />

            <DetailListings row={modValues.rowData} />
          </div>
        ) : (
          <DFApprovalForm
            userInfoData={userInfoData}
            closeModal={onCloseModal}
            callFunction={callFunction}
            rowData={modValues.rowData}
            isViewOnly={modValues.isViewOnly === true}
          />
        )}
      </Modal>

      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt15">
        {dfApprovalsLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allDatas.allData}
            tableColumns={tbColumns}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div>
    </>
  );
};

export default DFApprovalListings;
